import React from 'react';
import { cn } from 'utils/helpers';

type Props = {
  title: string;
  step: number;
  children: React.ReactNode;
};

const StepCard: React.FC<Props> = ({ title, step, children }) => {
  return (
    <div className={cn('flex flex-col gap-4')}>
      <div className="flex gap-2">
        <div className="">{`Step ${step}`}</div>
        <div className="font-semibold">{title}</div>
      </div>

      {children}
    </div>
  );
};

export default StepCard;
